class AnnouncementBar extends HTMLElement {
  constructor() {
    super();

    this.setHeightVariable();
    this.swiperInit();
  }

  setHeightVariable() {
    document.body.classList.add('announcement-bar-offset');
    document.documentElement.style.setProperty('--announcement-bar-height', `${this.offsetHeight - 1}px`);

    window.addEventListener('resize', () => {
      document.documentElement.style.setProperty('--announcement-bar-height', `${this.offsetHeight - 1}px`);
    });

    if (Shopify.designMode) {
      document.addEventListener('shopify:section:load', () => {
        const header = document.querySelector('site-header');
        document.body.classList.add('announcement-bar-offset');
        document.documentElement.style.setProperty('--announcement-bar-height', `${this.offsetHeight - 1}px`);

        if (this.classList.contains('announcement-bar--sticky')) {
          header.classList.remove('header--absolute');
        }
      });
    }
  }

  swiperInit() {
    const announcementBarSwiper = this.querySelector('[data-swiper]');

    if (!announcementBarSwiper) { return; }

    const prevButton = announcementBarSwiper.querySelector('[data-swiper-prev]');
    const nextButton = announcementBarSwiper.querySelector('[data-swiper-next]');

    const swiper = new window.Swiper(announcementBarSwiper, {
      slidesPerView: 1,
      loop: true,
      noSwiping: true,
      noSwipingClass: 'swiper-slide',
      navigation: {
        prevEl: prevButton,
        nextEl: nextButton
      },
      effect: 'fade',
      fadeEffect: {
        crossFade: true
      }
    });

    return swiper;
  }
}

customElements.define('announcement-bar', AnnouncementBar);